import React from 'react';
// Importing Carousel from 'react-material-ui-carousel'
// Note: This library needs to be installed via npm or yarn:
// npm install react-material-ui-carousel @mui/material @mui/icons-material
import Carousel from 'react-material-ui-carousel';
import { Paper, Button } from '@mui/material'; // Using @mui/material for Material UI v5

// Main App component which renders the ImageCarousel
function App() {
  // Define an array of items for the carousel, each with a name, description, and image URL.
  const items = [
    {
      name: "Majestic Mountains",
      description: "A breathtaking view of towering peaks and serene valleys.",
      image: "https://placehold.co/800x400/4CAF50/FFFFFF?text=Mountains+1"
    },
    {
      name: "Urban Metropolis",
      description: "The vibrant energy and dazzling lights of a modern city at night.",
      image: "https://placehold.co/800x400/2196F3/FFFFFF?text=Cityscape+2"
    },
    {
      name: "Abstract Waves",
      description: "An artistic representation of dynamic forms and fluid motion.",
      image: "https://placehold.co/800x400/FF5722/FFFFFF?text=Abstract+Art+3"
    },
    {
      name: "Golden Coastline",
      description: "The tranquil beauty of a sunset casting warm hues over the ocean shore.",
      image: "https://placehold.co/800x400/9C27B0/FFFFFF?text=Coastal+Sunset+4"
    },
    {
      name: "Forest Path",
      description: "A peaceful journey through a dense, green forest.",
      image: "https://placehold.co/800x400/FFEB3B/000000?text=Forest+Path+5"
    }
  ];

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-purple-50 p-4 font-sans antialiased">
      <div className="w-full max-w-4xl bg-white rounded-xl shadow-2xl overflow-hidden border border-gray-200">
        <Carousel
          autoPlay={true}             // Enable automatic slide transition
          animation="slide"           // Use a slide animation for transitions
          duration={800}              // Duration of the slide animation in milliseconds
          interval={5000}             // Interval between slide changes in milliseconds
          indicators={true}           // Show dot indicators at the bottom
          navButtonsAlwaysVisible={true} // Always show previous/next navigation buttons
          stopAutoPlayOnHover={true}  // Pause autoplay when hovering over the carousel
          cycleNavigation={true}      // Allow navigation to loop from last to first slide

          // Custom styling for the navigation buttons
          navButtonsProps={{
            style: {
              backgroundColor: '#1976d2', // Blue background for buttons
              color: '#fff',              // White icon color
              borderRadius: '50%',        // Make buttons circular
              padding: '8px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.2)', // Subtle shadow
              transition: 'all 0.3s ease-in-out', // Smooth transition for hover effects
              '&:hover': {
                backgroundColor: '#1565c0', // Slightly darker blue on hover
                transform: 'scale(1.1)',    // Slightly enlarge on hover
              }
            }
          }}
          // Custom styling for the container holding the indicators
          indicatorContainerProps={{
            style: {
              marginTop: '10px',        // Space above indicators
              textAlign: 'center',      // Center the indicators
              paddingBottom: '10px'     // Padding at the bottom
            }
          }}
          // Custom styling for the active indicator icon button
          activeIndicatorIconButtonProps={{
            style: {
              color: '#1976d2',         // Blue color for the active indicator
              transform: 'scale(1.2)',  // Make active indicator slightly larger
              transition: 'transform 0.3s ease-in-out'
            }
          }}
          // Custom styling for inactive indicator icon buttons
          indicatorIconButtonProps={{
            style: {
              color: 'gray',            // Gray color for inactive indicators
              transition: 'all 0.3s ease-in-out'
            }
          }}
        >
          {
            // Map through the items array and render an Item component for each
            items.map((item, i) => <Item key={i} item={item} />)
          }
        </Carousel>
      </div>
    </div>
  );
}

// Item component to display individual carousel slides
function Item({ item }) {
  return (
    <Paper
      className="p-6 text-center rounded-lg shadow-md flex flex-col justify-between items-center min-h-[500px] sm:min-h-[450px] bg-white transition-all duration-300 hover:shadow-xl"
      // Apply a subtle gradient background for visual appeal
      style={{
        background: 'linear-gradient(135deg, #f0f8ff 0%, #e0f2f7 100%)',
        margin: '10px' // Add some margin around each paper item
      }}
    >
      <img
        src={item.image}
        alt={item.name}
        className="max-w-full h-auto rounded-lg mb-4 object-cover border border-gray-200 shadow-sm transition-transform duration-300 hover:scale-[1.01]"
        style={{ maxHeight: '350px', width: '100%' }} // Max height for images
        // Fallback for broken image links
        onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/800x400/DC3545/FFFFFF?text=Image+Load+Error"; }}
      />
      <h2 className="text-3xl sm:text-2xl font-extrabold text-gray-800 mb-2 font-inter">
        {item.name}
      </h2>
      <p className="text-lg sm:text-md text-gray-600 mb-4 font-inter">
        {item.description}
      </p>
      <Button
        variant="contained"
        className="text-white font-semibold py-3 px-8 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
        style={{
          background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
          boxShadow: '0 3px 10px 2px rgba(33, 203, 243, .4)'
        }}
      >
        Explore More
      </Button>
    </Paper>
  );
}

export default App; // Export the App component as default
